import { HTMLAttributes } from 'react'

import { cn } from '@/lib/utils'

const ScrollCta = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={cn(
        'inline-flex h-[40px] w-[8px] items-start justify-center rounded bg-surface-secondary-invert-light p-[1.60px] dark:bg-surface-secondary-invert-dark',
        className
      )}
      {...props}
    >
      <div className="animate-scroll h-[24px] flex-1 rounded bg-surface-primary-light duration-1000 dark:bg-surface-primary-dark" />
    </div>
  )
}

export default ScrollCta
